// Temporarily paused at Pedro's request. Keep the MSR stage/video-wall popups
// on their legacy behavior, including for accounts allowed by the API policy.
// This flag does not control sales, preparation, or the published explorer.
export const FOCUSED_BUILDERS_ENABLED = false
